
import type { StoreState } from '@deqo/foundation';
import { memone, MutableRecordStore } from '@deqo/foundation';
import { BoardLiteData } from '../../api/ApiTypes';
import { BoardUsageData } from '../../api/endpoints/me';

const defaultState = {
    limit: -1,
    boards: [] as BoardLiteData[],
};

export class BoardUsageModel extends MutableRecordStore(defaultState) {

    public static create(data?: BoardUsageData) {
        const m = new BoardUsageModel();
        if (data) m.setState(data);
        return m;
    }

    public get enabled() {
        return this.limit > 0;
    }

    public get used() {
        return this.state.boards.length;
    }

    public get remaining() {
        if (this.limit < 0) return Infinity;
        return Math.max(0, this.limit - this.used);
    }

    public isBoardActive(boardId: string) {
        if (!this.enabled) return true;
        return this.computeBoardIdSet(this.state).has(boardId);
    }

    @memone()
    private computeBoardIdSet(state: StoreState<BoardUsageModel>) {
        return new Set(state.boards.map(b => b.id));
    }
}
